import { render, staticRenderFns } from "./NsfcEvaluation.vue?vue&type=template&id=449ac850&scoped=true"
import script from "./NsfcEvaluation.vue?vue&type=script&lang=js"
export * from "./NsfcEvaluation.vue?vue&type=script&lang=js"
import style0 from "./NsfcEvaluation.vue?vue&type=style&index=0&id=449ac850&prod&lang=less&scoped=true"
import style1 from "./NsfcEvaluation.vue?vue&type=style&index=1&id=449ac850&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449ac850",
  null
  
)

export default component.exports